module.exports = __webpack_public_path__ + "img/easiest_way.ad164add.svg";